"use client";

import { createSVGIcon } from "@faire/web/slate/icons/util";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import * as React from "react";

/**
 * @optimized using svgo:^3.0.2
 */
export const Close = createSVGIcon(
  <path stroke="currentColor" d="m2.667 2 11.07 11.552M2 13.07 13.552 2" />,
  "Close",
  () => ({
    viewBox: "0 0 15 15",
    strokeLinecap: "square",
    strokeWidth: 2,
    className: legacyIconCls(),
  })
);
